import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate() {

        if (localStorage.getItem('user')) {
            return true;
        } else {
            this.router.navigate(['/login']);
            return false;
        }

    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/core/guards/auth.guard.ts